import React from "react";
import { default as WDialog } from "@mui/material/Dialog";

function Dialog(props) {
  return <WDialog {...props} />;
}

export default Dialog;
